import type { GlobalCrawlConfigInput } from "@repo/adapter-core";
import { GlobalCrawlConfigSchema } from "@repo/adapter-core";
import { z } from "zod";

export const PropertyComAuAdapterConfigSchema = GlobalCrawlConfigSchema.extend({
  listingType: z.enum(["buy", "rent", "sold"]).default("buy"),
});

export type PropertyComAuAdapterConfig = z.infer<typeof PropertyComAuAdapterConfigSchema>;

export const PROPERTY_COM_AU_DEFAULT_CONFIG: GlobalCrawlConfigInput = {
  listingType: "buy",
};

export function resolvePropertyComAuConfig(
  config: GlobalCrawlConfigInput = {},
): PropertyComAuAdapterConfig {
  const listingType =
    config.listingType && config.listingType !== "any" ? config.listingType : "buy";
  return PropertyComAuAdapterConfigSchema.parse({
    ...PROPERTY_COM_AU_DEFAULT_CONFIG,
    ...config,
    listingType,
  });
}
